module.exports = "/wp-content/plugins/farmacy/assets/js/images/the_original_farm_logo_white-bfb92d8060c066c4f6fd169cdd91798e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/farm-branding/img/the_original_farm_logo_white.png
 ** module id = 206
 ** module chunks = 1 23 27 28 39 42 62 76 81 89 136
 **/